<div
  *ngIf="options"
  class="flex h-16 w-full justify-center"
  [ngStyle]="{
    backgroundColor: options.bgColor,
    color: options.textColor
  }"
>
  <div class="flex h-full w-full max-w-content items-center justify-between p-2.5">
    <div class="flex flex-col">
      <p class="text-lg font-bold leading-5 text-inherit">{{ options.header }}</p>
      <p class="text-lg leading-5 text-inherit">{{ options.subHeader }}</p>
    </div>

    <img *ngIf="!!options.logo" [src]="options.logo" alt="company logo" class="h-full" />
  </div>
</div>
